export enum MENU_TYPE {
	IIKO = 5,
	RKEEPER = 4,
	POSTER = 7
}
